import React, { PropTypes } from 'react';
import { Link } from 'react-router';

const CategoryLink = ({ title, slug, className }) => (
  <Link className={`${slug} ${className}`} to={`/help/${slug}/`}>
    { title }
  </Link>
);

CategoryLink.propTypes = {
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  className: PropTypes.string,
};


export default CategoryLink;



// WEBPACK FOOTER //
// ./help/components/category_link.jsx